import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["modal"];
  static modal;

  modalTargetConnected(element) {
    this.modal = new Modal(element)
    this.modal.show();
  }

  modalTargetDisconnected(element) {
    this.close();
  }

  close() {
    if (this.modal) {
      this.modal.hide();
      this.modal = undefined;
    }
  }

  show() {
    if (this.modal) {
      this.modal.show();
    }
  }

  toggle() {
    if (this.modal) {
      this.modal.toggle();
    }
  }

  hide() {
    if (this.modal) {
      this.modal.hide();
    }
  }

  openUrl({ params: { url } }) {
    Turbo.visit(url, { frame: "modal-container" });
  }

  toggleFullscreen({ currentTarget }) {
    if (!this.hasModalTarget) return;

    const dialog = this.modalTarget.querySelector(".modal-dialog");
    const isFullscreen = dialog.classList.toggle("modal-fullscreen");
    const icon = currentTarget.querySelector("i");
    icon.classList.toggle("bi-arrows-fullscreen", !isFullscreen);
    icon.classList.toggle("bi-fullscreen-exit", isFullscreen);
    currentTarget.setAttribute(
      "aria-label",
      isFullscreen ? currentTarget.dataset.exitLabel : currentTarget.dataset.enterLabel
    );
  }
}
